import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeCollectionList = (data) => {
	return {
		type: Types.STORE_COLLECTION_LIST,
		payload: data
	};
};

export const fetchCollectionList = (searchKey) => async (dispatch) => {
	let params = '?page=0&size=20';
	if (searchKey) params += `&search=${encodeURI(searchKey)}`;
	await ApiClient.GET('getMyCollections', params).then((response) => {
		dispatch(storeCollectionList(response.data.data));
	});
};

export const storeRoleBasedCollection = (data) => {
	return {
		type: Types.STORE_ROLE_BASED_COLLECTION_LIST,
		payload: data
	};
};

export const fetchRoleBasedCollection = (params) => async (dispatch) => {
	await ApiClient.GET('filterCategories', params).then((response) => {
		dispatch(storeRoleBasedCollection(response.data));
	});
};
